import { Validator } from "Application/Validation";
import { StudentSessionContext } from "./StudentSessionContext";

export class StudentSessionContextValidator extends Validator<StudentSessionContext> {
    constructor() {
        super();
        this.ruleFor("sessionStartTime").notNull().withMessage("Please select a start time of session");
        this.ruleFor("sessionEndTime").notNull().withMessage("Please select an end time of session");
        this.ruleFor("mentorId").notNull().withMessage("Please select a mentor").notEmpty().withMessage("Please select a mentor");
        this.ruleFor("attendance").notNull().withMessage("Please select an attendance").notEmpty().withMessage("Please select an attendance");

        this.ruleFor("activityTypeId")
            .notEmpty()
            .withMessage("Please select an activity")
            .when((model) => model.attendance === "1");

        this.ruleFor("documentCategoryId")
            .notNull()
            .withMessage("Please select a category")
            .notEmpty()
            .withMessage("Please select a category")
            .when((model) => model.filesViewModel?.model?.files!.length > 0);

        this.ruleFor("wellbeingId")
            .notEmpty()
            .withMessage("Please select an option for wellbeing")
            .when((model) => model.attendance === "1");

        this.ruleFor("involvementId")
            .notEmpty()
            .withMessage("Please select an option for involvement")
            .when((model) => model.attendance === "1");
    }
}
